import React from 'react';

export default function IconPR() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 22">
            <path
                fill="#FF4B55"
                d="M32 4.71H0V1.07C0 .763.247.516.552.516h30.896c.305 0 .552.247.552.552v3.642Z"
            />
            <path fill="#F5F5F5" d="M32 4.71H0v4.194h32V4.71Z" />
            <path
                fill="#FF4B55"
                d="M32 8.904H0v4.193h32V8.904ZM31.449 21.483H.552A.552.552 0 0 1 0 20.93V17.29h32v3.64a.552.552 0 0 1-.551.553Z"
            />
            <path fill="#F5F5F5" d="M32 13.097H0v4.193h32v-4.193Z" />
            <path
                fill="#41479B"
                d="m.204 21.35 15.271-10.006a.411.411 0 0 0 0-.688L.204.651A.543.543 0 0 0 0 1.069v19.862c0 .17.082.317.204.418Z"
            />
            <path
                fill="#F5F5F5"
                d="m5.637 8.44.575 1.726 1.82.014a.245.245 0 0 1 .144.442l-1.464 1.081.549 1.736a.245.245 0 0 1-.376.273l-1.481-1.058-1.48 1.058a.245.245 0 0 1-.377-.274l.549-1.735-1.464-1.08a.245.245 0 0 1 .144-.443l1.82-.014.575-1.727a.245.245 0 0 1 .466 0Z"
            />
        </svg>
    );
}
